module.exports = __webpack_public_path__ + "25949561eb8fc1687f46f20499d47158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-10.jpg
// module id = 1150
// module chunks = 0